const state = function () {
  return {
    loadingData: false,
    list: [],
    selectedCertificates: [],
    loadingCertificates: false,
    searchFields: {
      'CLASS.AFFILIATE.AFFILIATE_CODE': null,
      ISSUED_START_DATE: null,
      ISSUED_END_DATE: null,
      PRINTED_IND: -1
    }
  }
}

export default {
  ...state()
}

export const initialState = state()
